import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Observable } from 'rxjs';
import { GenericReportRequest } from '../domain/generic-report-request';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {

  private urlSigamos: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private httpClient: HttpClient) {
    this.urlSigamos = GLOBAL.URL_SIGAMOS + "reports";
  }

  getReportSales(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getReportSales', genericReportRequest, this.httpOptions);
  }

  getDataSales(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getDataSales', genericReportRequest, this.httpOptions);    
  }

  getReportOrders(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getReportOrders', genericReportRequest, this.httpOptions);
  }

  getDataOrders(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getDataOrders', genericReportRequest, this.httpOptions);
  }

  /**
   * Genera el informe de ventas detallado de carrito
   * 
   * @author Frank Edward Daza González
   * @version 2019-01-25
   * @param genericReportRequest
   */
  getReportSalesInDetail(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getReportSalesInDetail', genericReportRequest, this.httpOptions);
  }

  /**
   * Trae la información de ventas detallado de carrito.
   * 
   * @author Frank Edward Daza González
   * @version 2019-01-25
   * @param genericReportRequest 
   */
  getDataSalesInDetail(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getDataSalesInDetail', genericReportRequest, this.httpOptions);    
  }

  /**
   * Trae la información para el informe de ventas general sin paginación.
	 * 
   * @author Frank Edward Daza González
   * @version 2019-01-26
   * @param genericReportRequest 
   */
  getDataSalesWithoutPagination(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getDataSalesWithoutPagination', genericReportRequest, this.httpOptions);    
  }

  /**
   * Trae la información para el informe de ventas detallado sin paginación.
	 * 
   * @author Frank Edward Daza González
   * @version 2019-01-26
   * @param genericReportRequest 
   */
  getDataSalesInDetailWithoutPagination(genericReportRequest: GenericReportRequest): Observable<any> {
    return this.httpClient.post(this.urlSigamos + '/getDataSalesInDetailWithoutPagination', genericReportRequest, this.httpOptions);    
  }

}